import store from '../store'

export const userService = (data = '') => {
  // user can has multiple roles..
  const roles = store.getters['user/status'].info.authorities

  return {
    login: () => {
      window.localStorage.setItem('_x', JSON.stringify(data.id_token))
      window.localStorage.setItem('_idle', JSON.stringify(data.tokenValidityInMilliseconds))
      return true
    },

    logout: () => {
      window.localStorage.clear()
      return true
    },

    authorizeMainMenuItemAccess: (item) => {
      // example:
      // rules.profile = ['item01', 'item02']
      const rules = {}
      // old admin@localhost.com role
      rules['ROLE_ADMIN'] = ['Administration']
      rules['ROLE_SUPPLIER_ADMIN'] = ['Administration']
      // check if rule is exists
      let hasPermission = false
      roles.forEach(role => {
        if (!rules[role]) return

        hasPermission = rules[role].includes(item)
      })

      return hasPermission
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/userService.js